import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const Tonga: Country = {
    identifier: "Tonga",
    name: "Tonga",
    countryCode: "TO",
    group: CountryGroup.OCEANIA,
    isUNMember: true,
    flag: "🇹🇴",
    svgPath: "m 997.03275,515.8364 -0.106,0.174 -0.051,-0.002 -0.123,-0.101 -0.045,-0.068 0.188,-0.205 0.097,-0.016 0.13,0.069 -0.006,0.058 -0.084,0.091 z m -3.392,7.508 0.04,0 0.044,-0.088 0.151,-0.032 -0.017,0.095 -0.204,0.308 -0.128,-0.12 -0.374,-0.197 -0.075,-0.152 0.124,-0.115 -0.013,0.093 0.063,0.042 0.211,0.016 0.188,0.083 -0.117,0.027 0.107,0.04 z m 0.699,0.392 -0.016,0.45 -0.137,-0.206 -0.016,-0.096 0.139,-0.139 0.03,-0.009 z",
}
